import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Email'
      breadcrumbs={[
        {
          label: 'History',
        },
        {
          label: 'Email',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/history/email',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
